import { render } from "./totalAlunos.vue?vue&type=template&id=30c78bc0&scoped=true"
import script from "./totalAlunos.vue?vue&type=script&lang=js"
export * from "./totalAlunos.vue?vue&type=script&lang=js"

import "./totalAlunos.vue?vue&type=style&index=0&id=30c78bc0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c78bc0"]])

export default __exports__